<div class="row">
    <div class="col-sm-12 mb-0">
        <div>
            <a
                href=""
                (click)="viewSearchResults(); (false)"
                class="sg-link d-inline-block mb-1"
            >
                <mlp-ng-icon name="arrow-left-1"></mlp-ng-icon> Explore nearby venues
            </a>
        </div>


        <ng-template #tipMlpPartner>
            <div class="mlp-tooltip">
                <div class="--title">Trusted Playfinder Partner venue</div>
                <ul>
                    <li>Response within 24 hours</li>
                    <li>
                        If your time is unavailable, we'll endeavour to find a nearby alternative
                    </li>
                </ul>
            </div>
        </ng-template>

        <ng-template #tipMlpNonPartner>
            <div class="mlp-tooltip">
                <div>
                    <p>
                        This venue is NOT a Playfinder Partner - they can be slow getting back to you or might not at
                        all.
                    </p>
                    <p>
                        We encourage you to explore nearby Playfinder Partner venues instead!
                    </p>
                </div>
            </div>
        </ng-template>

        <ng-template #ngModalPartner>
            <mlp-ng-modal>
                <h3
                    class="sg-heading__h4"
                    header
                >
                    <mlp-ng-icon name="check-circle-1"></mlp-ng-icon> Trusted Playfinder Partner venue
                </h3>
                <div body>
                    <ul>
                        <li>Response within 24 hours</li>
                        <li>
                            If your time is unavailable, we'll endeavour to find a nearby alternative
                        </li>
                    </ul>
                    <div class="modalWindow modalWindow--button-container mt-2">
                        <mlp-ng-button
                            (click)="modalService.close()"
                            [button]="{ label: 'OK, got it', type: 'submit' }"
                            btnStyle="lighter"
                        ></mlp-ng-button>
                    </div>
                </div>
            </mlp-ng-modal>
        </ng-template>

        <ng-template #ngModalNonPartner>
            <mlp-ng-modal>
                <h3
                    class="sg-heading__h4"
                    header
                >
                    <mlp-ng-icon name="alert-circle"></mlp-ng-icon> Not a Playfinder Partner venue
                </h3>
                <div body>
                    <p>
                        This venue is NOT a Playfinder Partner - they can be slow getting back to you or might not at
                        all.
                    </p>
                    <p>
                        We encourage you to explore nearby Playfinder Partner venues instead!
                    </p>

                    <div class="modalWindow modalWindow--button-container mt-2">
                        <mlp-ng-button
                            (click)="modalService.close()"
                            [button]="{ label: 'OK, got it', type: 'submit' }"
                            btnStyle="lighter"
                        ></mlp-ng-button>
                    </div>
                </div>
            </mlp-ng-modal>
        </ng-template>

        <div class="mb-4">
            <h1 class="sg-heading__h2 d-inline tooltip--desktop">
                {{ venueService.venueData?.data.attributes.name }}

            </h1>

            <span
                *ngIf="!venueService.pitchData?.data.attributes.mlp"
                class="sg-rounded body1 bold px-3 tooltip--desktop partner"
                [placement]="'right'"
                [container]="'body'"
                [ngbTooltip]="tipMlpNonPartner"
            >
                Non-Partner
                <mlp-ng-icon
                    name="alert-circle"
                    class="ml-1"
                ></mlp-ng-icon>
            </span>

        </div>


        <mlp-ng-icon
            [name]="'check-circle-1'"
            class="sg-link"
            [placement]="'right'"
            [container]="'body'"
            [ngbTooltip]="tipMlpPartner"
            *ngIf="isBrowser && venueService.pitchData?.data.attributes.mlp"
        ></mlp-ng-icon>

        <div class="tooltip--mobile mb-4">
            <h2 class="sg-heading__h2 d-inline">
                {{ venueService.venueData?.data.attributes.name }}


                <mlp-ng-icon
                    *ngIf="venueService.pitchData?.data.attributes.mlp"
                    [name]="'check-circle-1'"
                    class="sg-link"
                    (click)="modalService.open(ngModalPartner, modalMobile)"
                ></mlp-ng-icon>
            </h2>

            <span
                *ngIf="!venueService.pitchData?.data.attributes.mlp"
                class="sg-rounded body1 bold d-block mt-1 px-3 partner"
                (click)="
                venueService.pitchData?.data.attributes.mlp
                ? modalService.open(ngModalPartner, modalMobile)
                : modalService.open(ngModalNonPartner, modalMobile)
            "
            >
                Non-Partner
                <mlp-ng-icon
                    name="alert-circle"
                    class="ml-1"
                ></mlp-ng-icon>
            </span>
        </div>


        <div
            *ngIf="statusBadge"
            class="mb-4"
        >
            <mlp-ng-badge [badge]="statusBadge"></mlp-ng-badge>
        </div>

        <ul class="list-inline mb-2">
            <li
                class="list-inline-item mb-2"
                *ngFor="let pitch of pitchesWithUniqueSports"
            >
                <a
                    class="sg-link__btn text-capitalize"
                    [routerLink]="[pitch.links.weblink]"
                    [ngClass]="{
            '-active':
              pitch.attributes.sport ==
              venueService.pitchData?.data.attributes.sport
          }"
                    (click)="searchListLinkService.setPreviouslyViewed(false)"
                >{{ pitch.attributes.sport }}</a>
            </li>
        </ul>

        <span
            class="sg-heading__h6 text-center"
            *ngIf="venueService.venueData?.data.attributes.source === activePlaces"
        >
            <span class="npv-text">Contains Data &copy; Sport England</span>
        </span>
    </div>
</div>

<!--Show it only on mobile-->
<div class="row d-md-none">
    <div class="col-sm-12 mb-3">
        <div ngbDropdown>
            <button
                type="button"
                class="btn btn-block btn-mlp-darker font-white cursor pointer"
                id="dropdownSelectSportFormat"
                ngbDropdownToggle
            >
                {{ venueService.pitchData?.data | sportFormatSurfaceText }}
            </button>
            <div
                class="dropdown-menu py-0 w-100"
                ngbDropdownMenu
                aria-labelledby="dropdownSelectSportFormat"
            >
                <ng-container *ngFor="let pitch of pitchesWithSameSport; let last = last">
                    <a
                        class="dropdown-item py-2"
                        href="#"
                        (click)="(false)"
                        [routerLink]="[pitch.links.weblink]"
                    >
                        {{ pitch | sportFormatSurfaceText }}
                    </a>
                    <div
                        class="dropdown-divider my-0"
                        *ngIf="!last"
                    ></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-sm-12 mb-3">
        <mlp-carousel></mlp-carousel>
    </div>
    <div
        class="col-sm-12 mb-3 d-none d-md-block"
        *ngIf="!venueService.pitchData?.data.attributes.mlp"
    >
        <div class="row">
            <div class="col-sm-6">
                <mlp-ng-button
                    [button]="{ label: 'Get In touch', type: 'button' }"
                    btnStyle="lighter"
                    fullWidth="1"
                    (click)="openContactVenueModal()"
                ></mlp-ng-button>
            </div>

        </div>
    </div>
</div>

<!-- Scroll to this point on mobile-->
<div id="mlp-calendar"></div>

<div
    class="row"
    *ngIf="venueService.pitchData?.data.attributes.online_booking"
>
    <div class="col-sm-12 mb-3">
        <mlp-calendar></mlp-calendar>
    </div>
</div>

<!--Show it only on mobile-->
<div
    class="row d-md-none"
    *ngIf="venueService.pitchData?.data.attributes.facilities.length > 0"
>
    <div class="col-sm-12 mb-2">
        <div class="card pf-card mb-2">
            <div class="card-header">
                <h4 class="h6 mb-0">
                    <span class="icon icon-mlp_{{
              lowercase(venueService.pitchData?.data.attributes.sport)
            }}"></span> Facilities
                </h4>
            </div>
            <div class="card-body">
                <ul class="list-inline font size12">
                    <li
                        class="list-inline-item"
                        *ngFor="
              let facility of venueService.pitchData?.data.attributes.facilities
            "
                    >
                        <mlp-ng-icon name="check-1"></mlp-ng-icon>
                        {{ facility }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-12 mb-sm-0 mb-md-3">
        <mlp-tabs [openMapEvent]="openMapEvent"></mlp-tabs>
    </div>
</div>

<div
    *ngIf="!venueService.pitchData?.data.attributes.mlp"
    class="fixed-bottom d-md-none mlp-fixed-container"
>
    <div class="row p-3">
        <div class="col-sm-6 col-6 text-center">
            <mlp-ng-button
                [button]="{ label: 'Claim Venue', type: 'button' }"
                fullWidth="1"
                btnStyle="tertiary"
                (click)="openClaimVenueModal()"
            ></mlp-ng-button>
            <span class="mt-3 sg-heading__h6 d-block pointer">
                OR LET US KNOW THESE DETAILS ARE INCORRECT
            </span>
        </div>
        <div class="col-sm-6 col-6">
            <mlp-ng-button
                [button]="{ label: 'Contact Venue', type: 'button' }"
                btnStyle="lighter"
                fullWidth="1"
                (click)="openContactVenueModal()"
            ></mlp-ng-button>
        </div>
    </div>
</div>

<ng-template #contactVenueModal>
    <mlp-venue-content-modal>
        <div
            class="m-3"
            header
        >
            <h3 class="sg-heading__h4 mb-3 text-center">Get in touch with this venue to book</h3>
            <div class="text-justify">
                This venue isn't a Playfinder partner; we have no affiliation with this venue, and cannot guarantee a
                response.
            </div>
        </div>
        <div body>
            <ng-container *ngIf="similarPitchData && similarPitchData.length > 0">
                <p class="sg-heading__h5 sg-rounded mlp-search-info p-3 my-2">
                    <mlp-ng-icon name="maps"></mlp-ng-icon>
                    <ng-container *ngIf="!venueService.pitchData?.data.attributes.mlp">
                        Book online at a nearby partner venue instead
                    </ng-container>
                    <ng-container *ngIf="venueService.pitchData?.data.attributes.mlp">
                        Nearby {{ venueService.pitchData?.data.attributes.sport | sportToPitchCourtText : "Venues" :
                        venueService.venueData : true }}
                    </ng-container>
                </p>
                <div class="row px-2">
                    <div
                        class="col-lg-4 col-sm-6 col-xs-6 col-6 card-body cursor pointer pb-0 p-2"
                        *ngFor="
              let similarData of similarPitchData
                | slice : 0 : similarPitchesDisplayCount;
              let last = last
            "
                    >
                        <legend
                            *ngIf="similarData.pitch.attributes.mlp"
                            class="sg-rounded body4 bold px-1"
                        >
                            Playfinder Partner
                            <mlp-ng-icon
                                name="check-circle-1"
                                class="ml-1"
                            ></mlp-ng-icon>
                        </legend>
                        <div>
                            <div>
                                <img
                                    class="media-object rounded pf-card__img"
                                    alt="{{ similarData.pitch.attributes.name }}"
                                    src="{{ similarData.pitch.attributes.images.medium[0] }}"
                                    width="100"
                                    height="66"
                                    imgService="w=170"
                                />
                            </div>
                            <div class="mt-3">
                                <h6 class="body2 font-weight-bold pitchname">
                                    {{ similarData.pitch.attributes.name }}
                                </h6>
                                <p class="mb-3 body3 font-weight-bold">
                                    <span class="sg-color body5 -secondary">
                                        <mlp-ng-icon
                                            name="style-two-pin-marker"
                                            class="body1"
                                        ></mlp-ng-icon>
                                        {{ milesAway(similarData.venue) }}
                                    </span>
                                    <span class="ml-1 font-italic body5">
                                        {{ similarData.pitch.attributes.available_slots_total }}
                                        bookings available
                                    </span>
                                </p>

                                <mlp-ng-button-icon
                                    btnSize="small"
                                    fullWidth="1"
                                    *ngIf="!areAvailableSlots(similarData.pitch)"
                                    label="View Venue"
                                    btnStyle="secondary"
                                    [routerLink]="[similarData.pitch.links.weblink]"
                                    (click)="modalService.close(); scrollToTheTop()"
                                ></mlp-ng-button-icon>

                                <mlp-ng-button-icon
                                    *ngIf="
                    areAvailableSlots(similarData.pitch) &&
                    !similarData.pitch.attributes.available_slots_total_sbt
                  "
                                    btnSize="small"
                                    fullWidth="1"
                                    label="Book "
                                    labelSecondary="Online"
                                    btnIcon="flash"
                                    [routerLink]="[similarData.pitch.links.weblink]"
                                    (click)="modalService.close(); scrollToTheTop()"
                                ></mlp-ng-button-icon>
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-sm-12 mt-3 text-sm-left text-center"
                        *ngIf="
              similarPitchData.length > 3 &&
              similarPitchesDisplayCount < similarPitchData.length
            "
                    >
                        <a
                            class="explore cursor pointer font-weight-medium"
                            (click)="similarPitchesDisplayCount = similarPitchData.length"
                        >
                            Explore more Partner Venues
                            <mlp-ng-icon
                                name="arrow-right-1"
                                class="ml-1"
                            ></mlp-ng-icon>
                        </a>
                    </div>
                </div>
            </ng-container>

            <div
                class="w-100"
                *ngIf="!isLoading && !success && validContactDetails"
                footer
            >
                <div class="border my-3 sg-color__primary py-3">
                    <p class="text-center text-justify">
                        We have found the following contact details for this venue:
                    </p>
                    <div class="row">
                        <span class="col-12 col-sm-6 text-center text-sm-right">
                            Phone:
                        </span>
                        <a
                            href="tel:{{ getVenueDataFromPitch()?.attributes.contact_number }}"
                            class="col-12 col-sm-6 text-center text-sm-left"
                        >
                            <mlp-ng-icon name="phone"></mlp-ng-icon>
                            {{ getVenueDataFromPitch()?.attributes.contact_number }}
                        </a>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12 col-sm-6">
                        <mlp-ng-button
                            (click)="sendVenueContactStatus(false)"
                            [button]="{ label: 'I was unable to contact this facility' }"
                            btnStyle="danger"
                            fullWidth="1"
                        ></mlp-ng-button>
                    </div>
                    <div class="col-12 col-sm-6">
                        <mlp-ng-button
                            (click)="sendVenueContactStatus(true)"
                            [button]="{ label: 'I contacted this facility successfully' }"
                            btnStyle="success"
                            fullWidth="1"
                        ></mlp-ng-button>
                    </div>
                </div>
            </div>
        </div>

    </mlp-venue-content-modal>
</ng-template>

<ng-template #claimVenueFormModal>
    <mlp-venue-content-modal [hideFooter]="true">
        <div
            class="m-3 w-100"
            header
        >
            <h3 class="sg-heading__h4 mb-3 text-center w-100">CONTACT US</h3>
            <div
                class="text-center"
                *ngIf="!isLoading && !success"
            >
                Do you own or manage {{ venueService.pitchData?.data.attributes.name }} or have you noticed incorrect
                details? <br /> Fill out the form below to help us verify your identity, and a member of our team will
                be in touch.
            </div>
        </div>
        <div body>
            <form
                [formGroup]="claimVenueFormGroup"
                autocomplete="off"
                novalidate="novalidate"
                #ngForm="ngForm"
                *ngIf="!isLoading && !success"
                (submit)="getVerified()"
                ngbAutofocus
            >
                <div class="row">
                    <div class="mb-2 col-sm-6">
                        <mlp-ng-input
                            formControlName="fullName"
                            placeholder="Your Full Name (OPTIONAL)"
                            [errors]="
                fullName.invalid && fullName.touched
                  ? [{ title: 'This field is required' }]
                  : []
              "
                            inputId="fullName"
                        ></mlp-ng-input>
                    </div>
                    <div class="mb-2 col-sm-6">
                        <mlp-ng-input
                            formControlName="email"
                            placeholder="Email Address"
                            [errors]="
                claimVenueEmail.invalid &&
                (claimVenueEmail.touched || ngForm.submitted)
                  ? [{ title: 'Valid email address is required' }]
                  : []
              "
                            inputId="email"
                        ></mlp-ng-input>
                    </div>
                    <div class="mb-2 col-sm-6">
                        <mlp-ng-input
                            formControlName="phoneNumber"
                            placeholder="Phone Number (OPTIONAL)"
                            [errors]="
                phoneNumber.invalid && phoneNumber.touched
                  ? [
                      {
                        title:
                          'A phone number can only contain 0-9 + ( ) and minimum 7 characters'
                      }
                    ]
                  : []
              "
                            inputId="phoneNumber"
                        ></mlp-ng-input>
                    </div>
                    <div class="mb-2 col-sm-6">
                        <mlp-ng-input
                            formControlName="role"
                            placeholder="Your Role (OPTIONAL)"
                            inputId="role"
                        ></mlp-ng-input>
                    </div>

                    <div class="mb-2 col-sm-12">
                        <textarea
                            class="form-control"
                            [class.is-invalid]="
                message.invalid && (message.touched || ngForm.submitted)
              "
                            formControlName="message"
                            rows="3"
                            placeholder="Provide us with more information."
                        ></textarea>
                    </div>
                </div>
                <mlp-ng-button
                    fullWidth="1"
                    [button]="{ label: 'Contact us' }"
                    btnType="submit"
                ></mlp-ng-button>
            </form>

            <mlp-ng-loading *ngIf="isLoading"></mlp-ng-loading>

            <ng-container
                *ngIf="success"
                [ngTemplateOutlet]="emailSuccessNotification"
                [ngTemplateOutletContext]="{ title: 'Verification Sent', contact: true }"
            >
            </ng-container>
        </div>
    </mlp-venue-content-modal>
</ng-template>


<ng-template
    #emailSuccessNotification
    let-title="title"
    let-contact="contact"
>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 offset-md-3 pb-5 pt-4">
                <hr class="sg-mb-1" />

                <h1 class="sg-heading__h2 text-center sg-mb-1 text-capitalize">
                    {{ title }}
                </h1>

                <hr class="sg-mb-1" />

                <div class="text-center sg-mb-1">
                    <mlp-ng-icon
                        size="large"
                        name="check-circle-1"
                    ></mlp-ng-icon>
                </div>

                <p class="sg-mb-1 text-center font-weight-bold">
                    Thanks for contacting Playfinder.
                </p>

                <p
                    class="sg-mb-1 text-center"
                    *ngIf="contact"
                >
                    A member of the team will be in touch with you soon.
                </p>
            </div>
        </div>
    </div>
</ng-template>